import { useGetOrganizationQuery } from "../../../store/apiSlice/accountApiSlice";

/**
 * Company setting that decides when warehouse stock leaves on a sale invoice.
 *
 * @returns {{ isInvoiceApprovalDepletion: boolean, trigger: string }}
 */
export const useSaleStockDepletionTrigger = () => {
  const { data } = useGetOrganizationQuery();
  const trigger =
    data?.operation_preference?.sale_stock_depletion_trigger?.id || "on_dispatch";
  return {
    isInvoiceApprovalDepletion: trigger === "on_invoice_approval",
    trigger,
  };
};
